import { useMemo } from "react";
import Loading from "../../../components/utils/Loading";
import { useTranslation } from "react-i18next";
import { useCollectionStatisticsData } from "../hooks/useCollectionStatisticsData";
import {
  buildFillingLevelByTimeChartData,
  buildFillingLevelGroupedBarChartData,
} from "../utils/collectionChartUtils";
import CollectionChartSection from "../components/CollectionChartSection";
import CollectionFillingRateSection from "../components/CollectionFillingRateSection";
import CollectionPerformanceSection from "../components/CollectionPerformanceSection";
import CollectionRecommendationsSection from "../components/CollectionRecommendationsSection";

const StatisticsChartComponent = ({
  statisticsCollectionCurrent,
  statisticsCollectionPrevious,
  packmatPerformance,
  recommendations = [],
  isLoading,
  chartCaptureRefs,
  fillingCaptureMode = null,
}) => {
  const { t } = useTranslation();

  const {
    data,
    trendByWasteCategoryPrevious,
    dataType,
    setDataType,
    displayData,
  } = useCollectionStatisticsData(
    statisticsCollectionCurrent,
    statisticsCollectionPrevious,
    packmatPerformance,
  );

  const { dataSetsFillingLevelGroupedBar, labelsByFluxChart } = useMemo(
    () => buildFillingLevelGroupedBarChartData(data, t),
    [data, t],
  );
  const { dataSetsFillingLevelByTime, labelsByTimeChart } = useMemo(
    () => buildFillingLevelByTimeChartData(data),
    [data],
  );

  return (
    <div>
      {!isLoading ? (
        Object.keys(data).length > 0 ? (
          <div className="flex flex-col gap-6">
            <section className="flex flex-col min-lg:flex-row min-lg:items-stretch gap-6 min-lg:h-[520px]">
              <CollectionFillingRateSection
                dataSetsFillingLevelGroupedBar={dataSetsFillingLevelGroupedBar}
                labelsByFluxChart={labelsByFluxChart}
                dataSetsFillingLevelByTime={dataSetsFillingLevelByTime}
                labelsByTimeChart={labelsByTimeChart}
                t={t}
                forceViewMode={fillingCaptureMode}
                chartPlotRef={(el) => {
                  if (chartCaptureRefs?.current) {
                    chartCaptureRefs.current.filling = el;
                  }
                }}
              />

              <CollectionRecommendationsSection
                recommendations={recommendations}
                t={t}
              />
            </section>

            <CollectionChartSection
              data={data}
              t={t}
              chartPlotRef={(el) => {
                if (chartCaptureRefs?.current) {
                  chartCaptureRefs.current.rotations = el;
                }
              }}
            />

            <CollectionPerformanceSection
              dataType={dataType}
              setDataType={setDataType}
              displayData={displayData}
              trendByWasteCategoryPrevious={trendByWasteCategoryPrevious}
              t={t}
            />
          </div>
        ) : (
          <section className="statistics-card flex flex-col items-center justify-center gap-2 py-10 text-center text-[#5e5e5e]">
            <span className="fas fa-exclamation-triangle text-xl"></span>
            <span>{t("No collection for the current period")}</span>
          </section>
        )
      ) : (
        <div>
          <Loading height={"55vh"} />
        </div>
      )}
    </div>
  );
};

export default StatisticsChartComponent;
